import {
  Backdrop,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import * as yup from "yup";
import CustomDataGrid from "../../../../../components/dataTable/customDataGrid";
import City from "../../../../../components/utils/dropDown/city";
import Country from "../../../../../components/utils/dropDown/country";
import State from "../../../../../components/utils/dropDown/state";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import Modal from "../../../../../components/utils/modal/modal";
import DeletePage from "../../../../../components/utils/deleteModal/deletePage";
import { useDispatch } from "react-redux";
import axios from "axios";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { Delete, EditNote } from "@mui/icons-material";
import _ from "lodash";
import Loader from "../../../../../components/loader/loader";
import { Helmet } from "react-helmet-async";

const Customers = () => {
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [active, setActive] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [balance, setBalance] = useState("");
  const [countryObj, setCountryObj] = useState(null);
  const [stateObj, setStateObj] = useState(null);
  const [cityObj, setCityObj] = useState(null);
  const [isLoader, setIsLoader] = useState(false); //loader

  const validation = yup.object({
    name: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .required("This field is required!"),
    // supplierCode:yup.string().matches(/^\d+$/, 'Only numbers are allowed!').max(2,"maximum length of 2 digits are allowed").min(2,"minumum length of 2 digits are allowed").required('This field is required!'),
    supplierCode: yup
      .string()
      .matches(/^\d+$/, "Only numbers are allowed!")
      .required("This field is required!"),
    address1: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .required("This field is required!"),
    address2: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .required("This field is required!"),
    country: yup.object().required("Select anyone Country"),
    state: yup.object().required("Select anyone state"),
    city: yup.object().required("Select anyone city"),
    phone: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .matches(/^\d+$/, "Only digits are allowed")
      .notRequired(),
    pincode: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .matches(/^\d+$/, "Only digits are allowed")
      .min(6, "Minimum 6 digits required")
      .max(8, "Maximum 6 digits allowed")
      .required("This field is required!"),
    mobile: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .matches(/^\d+$/, "Only digits are allowed")
      .notRequired(),
    email: yup
      .string("Enter your email")
      .email("Enter a valid email")
      .notRequired(),
    website: yup
      .string()
      .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        "Enter correct url!",
      )
      .notRequired(),
    gstin: yup.string().required("This field is required!"),
    fssai: yup.string().required("This field is required!"),
    bankAccNo: yup.string().notRequired(),
    // gstin:yup.string().matches(/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}\d{1}$/, 'Invalid GSTIN format').required('This field is required!'),
    // fssai:yup.string().matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Invalid PAN number format').required('This field is required!'),
    // bankAccNo:yup.string().matches(/^\d{9,18}$/, 'Invalid bank account number format').required('This field is required!'),
    bankName: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .notRequired(),
    accName: yup
      .string()
      .matches(/^\S.*$/, "Empty space not allowed!")
      .notRequired(),
    ifscCode: yup
      .string()
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format")
      .notRequired(),
    opBalance: yup
      .number()
      .required("Required")
      .required("This field is required!"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      supplierCode: "",
      country: null,
      state: null,
      city: null,
      address1: "",
      address2: "",
      phone: "",
      mobile: "",
      email: "",
      website: "",
      gstin: "",
      fssai: "",
      opBalance: "",
      bankAccNo: "",
      bankName: "",
      accName: "",
      ifscCode: "",
      pincode: "",
    },
    validationSchema: validation,
    onSubmit: isEdit ? handleUpdate : handleCreate,
  });

  const columns = [
    {
      field: "sno",
      headerName: "S.no",
      minWidth: 70,
      maxWidth: 100,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "name",
      headerName: "Supplier Name",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "supplierCode",
      headerName: "Supplier Code",
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "mobile",
      headerName: "Mobile No.",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "phone",
      headerName: "Phone No.",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "website",
      headerName: "Website",
      minWidth: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "isActive",
      headerName: "Status",
      minWidth: 180,
      disableExport: true,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="">
          <Chip
            size="small"
            color={params.row.isActive ? "success" : "error"}
            label={params.row.isActive ? "Active" : "Inactive"}
          />
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 180,
      minWidth: 100,
      disableExport: true,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className="flex justify-center w-full">
          <IconButton onClick={() => onEdit(params.row)}>
            <EditNote sx={{ color: "#1972d2", fontSize: 22 }} />
          </IconButton>
          <IconButton onClick={() => OnDelete(params.id)}>
            <Delete sx={{ color: "red", fontSize: 22 }} />
          </IconButton>
        </div>
      ),
    },
  ];

  const rows = _.map(data, (val, idx) => ({
    id: val.id,
    sno: ++idx,
    balance: val.balance,
    add1: val.add1,
    add2: val.add2,
    add3: val.add3,
    add4: val.add4,
    name: val.name,
    supplierCode: val.short_name,
    stateId: val.state,
    website: val.website,
    email: val.email,
    phone: val.phone,
    mobile: val.mobile,
    countryId: val.country,
    stateId: val.state,
    cityId: val.city,
    companyId: val.company_id,
    isActive: val.is_active,
    opBal: val.op_bal,
    ifscCode: val.ifsccode,
    accName: val.ac_name,
    bankAccNo: val.bank_ac_no,
    bankName: val.bankname,
    custType: val.custtype,
    gstIn: val.gstin,
    fssai: val.fssaino,
    pincode: val.pincode,
  }));

  const props = {
    rows: rows,
    columns: columns,
    search: search,
    setSearch: setSearch,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    pageOption: pageOption,
  };

  const onCreate = () => {
    setOpen(true);
    formik.resetForm();
    setIsEdit(false);
    setCountryObj(null);
    setCityObj(null);
    setStateObj(null);
  };

  function handleCreate() {
    const custData = {
      name: formik.values.name,
      short_name: formik.values.supplierCode,
      add1: formik.values.address1,
      add2: formik.values.address2,
      add3: "-",
      add4: "-",
      country: formik.values.country.id,
      city: formik.values.city.id,
      pincode: formik.values.pincode,
      state: formik.values.state.id,
      phone: formik.values.phone === "" ? "-" : formik.values.phone,
      mobile: formik.values.mobile === "" ? "-" : formik.values.mobile,
      email: formik.values.email === "" ? "-" : formik.values.email,
      website: formik.values.website === "" ? "-" : formik.values.website,
      gstin: formik.values.gstin,
      custtype: 0,
      bank_ac_no:
        formik.values.bankAccNo === "" ? "-" : formik.values.bankAccNo,
      bankname: formik.values.bankName === "" ? "-" : formik.values.bankName,
      ac_name: formik.values.accName === "" ? "-" : formik.values.accName,
      ifsccode: formik.values.ifscCode === "" ? "-" : formik.values.ifscCode,
      company_id: 1,
      is_active: active,
      fssaino: formik.values.fssai,
      op_bal: formik.values.opBalance,
    };
    setIsLoader(true);
    axios
      .post(`/v1/supplier`, custData)
      .then((res) => {
        dispatch(setSnackbar(true, "success", "Created Successfully"));
        setOpen(false);
        getCustomerData();
        setIsLoader(false);
      })
      .catch((err) => {
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
        setIsLoader(false);
      });
  }

  function onEdit(e) {
    formik.resetForm();
    console.log(e);
    setBalance(e.balance);
    formik.setFieldValue("name", e.name);
    formik.setFieldValue("supplierCode", e.supplierCode);
    formik.setFieldValue("address1", e.add1);
    formik.setFieldValue("address2", e.add2);
    formik.setFieldValue("address3", "-");
    formik.setFieldValue("address4", "-");
    formik.setFieldValue("website", e.website);
    formik.setFieldValue("email", e.email);
    formik.setFieldValue("phone", e.phone === "-" ? "" : e.phone);
    formik.setFieldValue("mobile", e.mobile === "-" ? "" : e.mobile);
    formik.setFieldValue("opBalance", e.opBal);
    formik.setFieldValue("bankAccNo", e.bankAccNo);
    formik.setFieldValue("bankName", e.bankName);
    formik.setFieldValue("accName", e.accName);
    formik.setFieldValue("ifscCode", e.ifscCode);
    formik.setFieldValue("gstin", e.gstIn);
    formik.setFieldValue("fssai", e.fssai);
    formik.setFieldValue("pincode", e.pincode);
    setCountryObj(e.countryId);
    setStateObj(e.stateId);
    setCityObj(e.cityId);
    setIsEdit(true);
    setOpen(true);
    setActive(e.isActive);
    setActiveId(e.id);
  }
  function handleUpdate() {
    const custData = {
      name: formik.values.name,
      short_name: formik.values.supplierCode,
      add1: formik.values.address1,
      add2: formik.values.address2,
      add3: "-",
      add4: "-",
      country: formik.values.country.id,
      city: formik.values.city.id,
      pincode: formik.values.pincode,
      state: formik.values.state.id,
      phone: formik.values.phone === "" ? "-" : formik.values.phone,
      mobile: formik.values.mobile === "" ? "-" : formik.values.mobile,
      email: formik.values.email === "" ? "-" : formik.values.email,
      website: formik.values.website === "" ? "-" : formik.values.website,
      gstin: formik.values.gstin,
      custtype: 0,
      bank_ac_no:
        formik.values.bankAccNo === "" ? "-" : formik.values.bankAccNo,
      bankname: formik.values.bankName === "" ? "-" : formik.values.bankName,
      ac_name: formik.values.accName === "" ? "-" : formik.values.accName,
      ifsccode: formik.values.ifscCode === "" ? "-" : formik.values.ifscCode,
      company_id: 1,
      is_active: active,
      fssaino: formik.values.fssai,
      op_bal: formik.values.opBalance,
    };
    setIsLoader(true);
    axios
      .put(`/v1/supplier/${activeId}`, custData)
      .then((res) => {
        dispatch(setSnackbar(true, "success", "Updated Successfully"));
        setOpen(false);
        getCustomerData();
        setIsLoader(false);
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
        setIsLoader(false);
      });
  }

  function OnDelete(id) {
    setOpenDialog(true);
    setActiveId(id);
  }

  const handleDelete = () => {
    setIsLoader(true);
    axios
      .delete(`/v1/supplier/${activeId}`)
      .then((res) => {
        dispatch(setSnackbar(true, "success", "Deleted Successfully"));
        setOpenDialog(false);
        getCustomerData();
        setIsLoader(false);
        setOpen(false);
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
        setIsLoader(false);
      });
  };

  const getCustomerData = () => {
    const url = `/v1/supplier/${rowsPerPage}/${page + 1}`;
    const searchUrl = `/v1/supplier/${rowsPerPage}/${page + 1}/${search}`;
    setIsLoader(true);
    axios
      .get(search === "" ? url : searchUrl)
      .then((res) => {
        setData(res.data.data);
        setPageCount(res.data.meta.pagination.total);
        setIsLoader(false);
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          setSnackbar(true, "error", err.response.data.errors[0].message),
        );
        setIsLoader(false);
      });
  };
  const handleMobile = (e) => {
    formik.setFieldValue("mobile", e.target.value.replace(/\D/g, "").trim());
  };
  const handlePhone = (e) => {
    formik.setFieldValue("phone", e.target.value.replace(/\D/g, "").trim());
  };

  const handleAcc = (e) => {
    formik.setFieldValue("bankAccNo", e.target.value.replace(/\D/g, "").trim());
  };
  useEffect(() => {
    getCustomerData();
  }, [rowsPerPage, search, page]);
  console.log(formik.errors);
  return (
    <Fragment>
      <Helmet>
        <title>Supplier</title>
      </Helmet>
      <div className="flex justify-between">
        <Typography variant="h5">Supplier</Typography>
        {!open && (
          <Grid className="flex justify-end">
            <Button variant="contained" size="small" onClick={onCreate}>
              Create New
            </Button>
          </Grid>
        )}
      </div>

      {open && (
        <Modal
          onClose={setOpen}
          onSave={formik.handleSubmit}
          formik={formik}
          isEdit={isEdit}
        >
          <div style={{ textAlign: "right" }}>
            <Button variant="outlined" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {" "}
              <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>
                1. Company Details
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="name"
                value={formik.values.name}
                title="Name"
                multiple={false}
                placeholder="Enter name"
                onchange={formik.handleChange}
                errorMsg={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="supplierCode"
                value={formik.values.supplierCode}
                title="Supplier Code"
                multiple={false}
                placeholder="Enter supplier Code"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.supplierCode &&
                  Boolean(formik.errors.supplierCode)
                }
                helperText={
                  formik.touched.supplierCode && formik.errors.supplierCode
                }
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="address1"
                value={formik.values.address1}
                title="Address 1"
                multiple={true}
                placeholder="Enter address"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.address1 && Boolean(formik.errors.address1)
                }
                helperText={formik.touched.address1 && formik.errors.address1}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="address2"
                value={formik.values.address2}
                title="Address 2"
                multiple={true}
                placeholder="Enter address"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.address2 && Boolean(formik.errors.address2)
                }
                helperText={formik.touched.address2 && formik.errors.address2}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="pincode"
                value={formik.values.pincode}
                title="Pincode"
                multiple={false}
                placeholder="Enter pincode"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.pincode && Boolean(formik.errors.pincode)
                }
                helperText={formik.touched.pincode && formik.errors.pincode}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Country formik={formik} countryId={countryObj} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <State formik={formik} stateId={stateObj} />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <City formik={formik} cityId={cityObj} />
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>
                2. Contact Details
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="phone"
                value={formik.values.phone}
                title="Phone"
                multiple={false}
                placeholder="Enter phone No"
                onchange={handlePhone}
                errorMsg={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="mobile"
                value={formik.values.mobile}
                title="Mobile"
                multiple={false}
                placeholder="Enter mobile No"
                onchange={handleMobile}
                errorMsg={
                  formik.touched.mobile && Boolean(formik.errors.mobile)
                }
                helperText={formik.touched.mobile && formik.errors.mobile}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="email"
                value={formik.values.email}
                title="Email"
                multiple={false}
                placeholder="Enter email"
                onchange={formik.handleChange}
                errorMsg={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="website"
                value={formik.values.website}
                title="Website"
                multiple={false}
                placeholder="Enter website"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.website && Boolean(formik.errors.website)
                }
                helperText={formik.touched.website && formik.errors.website}
              />
            </Grid>
            {/* <Grid item xs={12} md={4} lg={3}>
    <Typography variant="body1" my={1}> Outlet Type</Typography>
    <FormControl sx={{ display: "flex" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="custType"
        id="custType"
        sx={{ flexDirection: "row", display: "flex" }}
        onChange={formik.handleChange}
      >
        <FormControlLabel
          value="Customer"
          control={<Radio size="small" checked={formik.values.custType==='Customer'} />}
          label="Customer"
        />
        <FormControlLabel
          value="Supplier"
          control={<Radio size="small"  checked={formik.values.custType==='Supplier'}/>}
          label="Supplier"
        />
      </RadioGroup>
      <Typography sx={{color:"red",fontSize:12}}>{formik.touched.custType && formik.errors.custType}</Typography>
    </FormControl>
    </Grid> */}
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>
                3. GST Details
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="gstin"
                value={formik.values.gstin}
                title="GSTIN"
                multiple={false}
                placeholder="Enter gstin"
                onchange={formik.handleChange}
                errorMsg={formik.touched.gstin && Boolean(formik.errors.gstin)}
                helperText={formik.touched.gstin && formik.errors.gstin}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="fssai"
                value={formik.values.fssai}
                title="Pan Number"
                multiple={false}
                placeholder="Enter Pan Number"
                onchange={formik.handleChange}
                errorMsg={formik.touched.fssai && Boolean(formik.errors.fssai)}
                helperText={formik.touched.fssai && formik.errors.fssai}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>
                4. Balance Details
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="opBalance"
                value={formik.values.opBalance}
                title="op.Balance"
                multiple={false}
                placeholder="Enter Op.Balance"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.opBalance && Boolean(formik.errors.opBalance)
                }
                helperText={formik.touched.opBalance && formik.errors.opBalance}
              />
            </Grid>
            {isEdit && (
              <Grid item xs={12} md={4} lg={3}>
                <Typography
                  variant="body1"
                  fontSize={20}
                  fontWeight={600}
                  mb={0.8}
                >
                  Balance : {balance}
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Typography fontSize={16} fontWeight={600} color={"#A06EE1"}>
                5. Bank Details
              </Typography>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="bankAccNo"
                value={formik.values.bankAccNo}
                title="Bank Acc No"
                multiple={false}
                placeholder="Enter Bank Acc No"
                onchange={handleAcc}
                errorMsg={
                  formik.touched.bankAccNo && Boolean(formik.errors.bankAccNo)
                }
                helperText={formik.touched.bankAccNo && formik.errors.bankAccNo}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="bankName"
                value={formik.values.bankName}
                title="Bank Name"
                multiple={false}
                placeholder="Enter Bank Name"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.bankName && Boolean(formik.errors.bankName)
                }
                helperText={formik.touched.bankName && formik.errors.bankName}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="accName"
                value={formik.values.accName}
                title="Account Holder Name"
                multiple={false}
                placeholder="Enter Account Holder Name"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.accName && Boolean(formik.errors.accName)
                }
                helperText={formik.touched.accName && formik.errors.accName}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <CustomTextField
                id="ifscCode"
                value={formik.values.ifscCode}
                title="IFSC Code"
                multiple={false}
                placeholder="Enter IFSC Code"
                onchange={formik.handleChange}
                errorMsg={
                  formik.touched.ifscCode && Boolean(formik.errors.ifscCode)
                }
                helperText={formik.touched.ifscCode && formik.errors.ifscCode}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={3} className="flex items-center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={active}
                    onChange={() => setActive(!active)}
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>
        </Modal>
      )}
      <Grid className="bg-white rounded-md p-2 my-3">
        <CustomDataGrid props={props} />
      </Grid>
      <Backdrop open={openDialog} sx={{ zIndex: 1350 }}>
        <DeletePage onCancel={setOpenDialog} onSubmit={handleDelete} />
      </Backdrop>
      {/* <Loader isLoader={isLoader} /> */}
    </Fragment>
  );
};

export default Customers;
